import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Typography from '../typography';
import Ruler from '../ruler';

const Quote = styled(Typography)`
  color: ${(props) => props.theme.color.brand};
  padding: 0 ${(props) => props.theme.modularScale.large};
  text-align: center;
`;

const Blockquote = (props) => (
  <>
    <Quote element="blockquote" like="heading-3">{ props.data.quote }</Quote>
    { props.data?.hr && <Ruler /> }
  </>
);

Blockquote.propTypes = {
  data: PropTypes.object.isRequired
};

export default Blockquote;
